// extracted by mini-css-extract-plugin
module.exports = {"sectionMember":"Index_sectionMember_1DbS4","Box":"Index_Box_1qWC2"};